import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { initiateSwipePaymentAPI } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const initiatePayment = createAsyncThunk('get/initiatePayment', initiateSwipePaymentAPI);

export const InitiateSwipePaymentSlice = createSlice({
	name: 'initiatePayment',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[initiatePayment.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[initiatePayment.rejected.toString()]: setAPIError,
		[initiatePayment.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[InitiateSwipePaymentSlice.name]: ReturnType<typeof InitiateSwipePaymentSlice.reducer>;
}

export const initiatePaymentSelector = (state: IStates): any => {
	return state[InitiateSwipePaymentSlice.name] || {};
};

export const useInitiateSwipePayment = (): any => useSelector(initiatePaymentSelector);

export const initiateSwipePayment =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(initiatePayment(params));
		return;
	};

export const resetInitiateSwipePayment =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(InitiateSwipePaymentSlice.actions.RESET());
		return;
	};
